import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Sticky from 'Components/Sticky/index';
import ActionLoader from 'Components/ActionLoader/index';
import { connect } from 'react-redux';
import { Table } from "reactstrap";
import {
    GET_EVENT_STATUS
} from 'Constants/actionConstants';
import { getUser } from 'Utils/storage';
import Moment from 'moment';

class EventStatus extends Component {
    constructor() {
        super();
        this.state = {
            data: [],
            isLoader: true
        }
    }

    componentDidMount() {
        this.getEventStatus();
    }

    getEventStatus = () => {
        const { dispatch, match } = this.props;
        dispatch({
            type: GET_EVENT_STATUS,
            params: {
                eventId: match.params.eventId,
                companyId: getUser().companyId
            },
            onSuccess: () => {
                this.setStatuTimer();
            }
        });
    }

    setStatuTimer = () => {
		if (this.unmounted) { return };
		if (this.setTimer) {
			clearTimeout(this.setTimer);
		}
		this.setTimer = setTimeout(() => {
			this.getEventStatus();
		}, 10000);

	}

    componentWillUnmount() {
		this.unmounted = true;
		if (this.setTimer) {
			clearTimeout(this.seekerBidsTimer);
		}
	}

    getStatus = (id) => {
        const statusObj = {
            color: '',
            value: ''
        }
        if(id === 2) {
            statusObj.color = '#FF9900';
            statusObj.value = 'Yet To start';
        } else if(id === 3) {
            statusObj.color = '#OCO6f7';
            statusObj.value = 'In Progress';
        } else if(id === 5) {
            statusObj.color = '#78A55A';
            statusObj.value = 'Completed';
        } else if(id === 6) {
            statusObj.color = 'red';
            statusObj.value = 'Canceled';
        }
        return statusObj;
    }

    render() {
        const { eventStatus } = this.props;

        return(
            <Sticky>
                <div
                className="pv-20 ph-20"
                style={{ backgroundColor: "#e3e9ff", height: "760px" }}
                >
                {/* {isLoader && <ActionLoader fixed={true} />} */}
                    <div>
                        <Link
                            className="ht-30 theme-color fs-20 flex flex-middle wt-max-content mb-10 mt-5"
                            to={`/eventManagement`}
                        >
                            <b>{'< Back'}</b>
                        </Link>
                    </div>
                    <Table className="upload-rfq-table status-table-height" striped responsive>
                        <thead>
                            <tr>
                                <th className="upload-td-th upload-th">RFQ Name</th>
                                <th className="upload-td-th upload-th">RA Strategy</th>
                                <th className="upload-td-th upload-th">No of Lanes</th>
                                <th className="upload-td-th upload-th">Date</th>
                                <th className="upload-td-th upload-th">Start Time</th>
                                <th className="upload-td-th upload-th">End Time</th>
                                <th className="upload-td-th upload-th">Hours / Mins</th>
                                <th className="upload-td-th upload-th">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(eventStatus || []).map((event, evtIndex) => ( <tr>
                                <td className="upload-td-th">{event.rfq_name}</td>
                                <td className="upload-td-th">{event.is_accept_partial_solution ? "Partial Solution" : "Complete Solution"}</td>
                                <td className="upload-td-th">{event.trips_count}</td>
                                <td className="upload-td-th">{event.bidding_start && Moment(event.bidding_start).format('DD/MM/YYYY') || ''}</td>
                                <td className="upload-td-th">{event.bidding_start && Moment(event.bidding_start).format('hh:mm:ss a') || ''}</td>
                                <td className="upload-td-th">{event.bidding_end && Moment(event.bidding_end).format('hh:mm:ss a') || ''}</td>
                                <td className="upload-td-th">{event.event_bid_duration_name}</td>
                                <td className="upload-td-th"><div style={{'color': (this.getStatus(event.status) || {}).color}} className="fBold">{event.status && (this.getStatus(event.status) || {}).value}</div></td>
                            </tr>))}
                        </tbody>
                    </Table>
                </div>
            </Sticky>
        )
    }
}

const mapStateToProps = ({ contracting }) => {
    return {
        eventStatus: contracting.eventStatus || []
    }
}

export default connect(mapStateToProps)(EventStatus); 